import { render } from "./CharlaPrice.vue?vue&type=template&id=43926282&scoped=true"
import script from "./CharlaPrice.vue?vue&type=script&lang=js"
export * from "./CharlaPrice.vue?vue&type=script&lang=js"

import "./CharlaPrice.vue?vue&type=style&index=0&id=43926282&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43926282"]])

export default __exports__